import React from "react";
import axiosInstance from "../services/AxiosInstance";
import { RouteComponentProps, withRouter } from "react-router-dom";
import styles from "./css/Evaluation.module.css";
import { IonContent, IonHeader, IonPage, IonToolbar, IonAlert } from "@ionic/react";


interface EvaluationProps extends RouteComponentProps {
    // Define props here
}

interface EvaluationState {
    // Define State here
}

class Evaluation extends React.Component<EvaluationProps, EvaluationState> {
    state = {
        value: 0,
        resultId: 0,

        goBack: false,

        // nav params //
        moodQuestionList: [{
            moodQuestion: "",
            questionId: 0
        }],
        aantalVragen: 0,
        challengeId: 0,
        score: 0,
        isLastChallenge: false,
        userChallengeId: 0,
    };

    constructor(props: EvaluationProps) {
        super(props);
        this.getStateValues();
    }

    componentDidMount(){
        window.history.pushState(null, "", window.location.href);
        window.addEventListener("popstate", this.onBrowserBackEvent);
    }
    
    componentWillUnmount() {
        window.removeEventListener("popstate", this.onBrowserBackEvent)
      }
    
    onBrowserBackEvent = () => {
        window.history.pushState(null, "", window.location.href);
        this.setState({goBack: true})
    }
    
    
    async getStateValues() {
        this.state.moodQuestionList = JSON.parse(localStorage.getItem("moodQuestionList") as string);
        this.state.aantalVragen = Number(localStorage.getItem("aantalVragen"))
        this.state.score = Number(localStorage.getItem("score"));
        this.state.userChallengeId = Number(localStorage.getItem("userChallengeId"));
        this.state.challengeId = Number(localStorage.getItem("challengeId"));

        let isLastChallenge = localStorage.getItem("isLastChallenge");
        if(isLastChallenge === "true") {
            this.state.isLastChallenge = true
        } else {
            this.state.isLastChallenge = false
        }

        this.setState({state: this.state})

        this.getResultId();
    }

    async goBackHandler() {
        var token = await localStorage.getItem("token");
        var employeeId = await localStorage.getItem("id");
    
        const config = {
          headers: {
            Authorization: "Bearer " + token,
          },
        };
    
        const {history} = this.props;
    
        axiosInstance.post(
          "/Results",
          {
            score: -1,
            selfEvaluationScore: -1,
            challengeId: this.state.challengeId,
            employeeId: employeeId,
          },
          config
        );
    
        axiosInstance
        .put(
            "/UserChallenges/" + this.state.userChallengeId,
            {
                id: this.state.userChallengeId,
                userId: employeeId,
                challengeId: this.state.challengeId,
                isFinished: true,
            },
            config
        )
        .catch((error) => {
                console.log(error);
        });

        if (this.state.isLastChallenge) {
            axiosInstance
            .put(
            "/UserSubjects/" + localStorage.getItem("userSubjectId"),
            {
                id: localStorage.getItem("userSubjectId"),
                userId: employeeId,
                subjectId: localStorage.getItem("subjectId"),
                isFinished: true,
            },
            config
            )
            .catch((error) => {
                console.log(error);
            });
            localStorage.setItem('reloadCount', String(1));
            history.push("/portal");
        } else {
            localStorage.setItem('reloadCount', String(1));
            history.push("/Case", { currentChallengeIsFinished: true });
        }
     }

    async getResultId() {
        var token = localStorage.getItem("token");
        var employeeId = localStorage.getItem("id");

        const config = {
            headers: {
                Authorization: "Bearer " + token,
            },
        };

        axiosInstance
        .get(
            "/Results/Employee/" +
            employeeId +
            "/Challenges/" +
            this.state.challengeId,
            config
        )
        .then((response: any) => {
            this.state.resultId = response.data.id;

            this.setState({ state: this.state });
        });
    }

    async pressAction() {
        var token = localStorage.getItem("token");
        var employeeId = localStorage.getItem("id");
        const {history} = this.props;

        if (this.state.value < 0 || this.state.value > this.state.aantalVragen) {
            alert("Dit kan niet je geschatte score zijn");
        } else {
            const config = {
                headers: {
                    Authorization: "Bearer " + token,
                },
            };
            
            axiosInstance
            .put(
                "/Results/" + this.state.resultId,
                {
                    selfEvaluationScore: this.state.value,
                    score: this.state.score,
                    employeeId: employeeId,
                    challengeId: this.state.challengeId,
                    id: this.state.resultId,
                },
                config
            )
            .catch((error) => {
                console.log(error);
            });
            localStorage.setItem("moodQuestionIndex", "" + 2)
            localStorage.setItem("isLastMoodQuestion", "" + true)
           
            localStorage.setItem("reloadCount", String(1))
            history.push("/MoodQuestion")
        }
    }

    render() {
        return (
            <IonPage ion-no-header="true">
                <IonHeader class="ion-no-border">
                    <IonToolbar>
                    <button className="backButton" onClick={() => { this.setState({ goBack: true }) }}>&larr;</button>
                    </IonToolbar>
                </IonHeader>
                <IonAlert
                isOpen= {this.state.goBack}
                header= "Pas op!"
                message= "Bij terugkeren of afsluiten zal de challenge worden verzonden met een 0-score"
                buttons={[
                    {
                        text: "Annuleer",
                        handler: () => {this.setState({goBack:false})}
                    },
                    {
                        text: "Oké",
                        handler: () => this.goBackHandler()
                    }
                ]}
                />
                <IonContent fullscreen>
                    <div>
                        <div className={styles.schermdeel}>
                            <div className={styles.titleText}>
                                <div className={styles.textFontBold}>
                                    <p>Hoeveel geef je jezelf voor deze challenge?</p>
                                </div>
                            </div>
                        </div>

                        <div className={styles.button}>
                            <div className={styles.answerText}>
                                <div className={styles.textFont}>
                                    <p>
                                        {this.state.value} / {this.state.aantalVragen}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className={styles.button}>
                            <input type="number"
                                value={this.state.value}
                                onChange={(e) => this.setState({ value: e.target.value })}
                                width="90%"
                                height="8%"
                                max={this.state.aantalVragen||"2"}
                                min="0"
                                step="1"
                                color="white"
                                className={(styles.input)}
                            />
                        </div>

                        <div>
                            <div
                                className={styles.button}
                                onClick={() => this.pressAction()}
                            >
                                <div className={styles.submitButton}>
                                    <div className={styles.textFontBold}>
                                        <p>Dien in</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </IonContent>
            </IonPage>
        );
    }
}

export default withRouter(Evaluation);
